<template>
    <v-dialog persistent max-width="800" v-model="active">
        <v-sheet class="d-flex">
            <v-col cols="6">
                <v-text-field v-model="searchTerms" label="Search" placeholder="Podcasts or creators" @keydown.enter="search" prepend-icon="mdi-podcast"></v-text-field>
                <v-list dense class="scrollable">
                    <v-list-item-group v-model="selectedResult" color="primary">
                        <v-list-item v-for="(item, i) in searchResults.results" :key="i" :value="item">
                            <v-list-item-avatar tile>
                                <v-img :src="$directoryApi.iTunes.artwork100Route(item.collectionId)" />
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title v-text="item.collectionName" />
                                <v-list-item-subtitle v-text="item.artistName" />
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-item-group>
                </v-list>
            </v-col>
            <v-col cols="6" v-if="this.selectedResult">
                <div>{{ selectedResult.collectionName }}</div>
                <img :src="this.selectedResult.artworkUrl100" width="100px" height="100px" />
                <v-btn @click="yes">Add</v-btn>
                <v-btn @click="no">Cancel</v-btn>
            </v-col>
        </v-sheet>
    </v-dialog>
</template>

<script>
export default {
    name: 'AppleSearch',
    components: {},
    data() {
        return {
            active: false,
            resolve: null,
            reject: null,

            searchTerms: '',
            searchResults: [],
            selectedResult: null,
        }
    },
    methods: {
        async search() {
            try {
                var response = await this.$directoryApi.iTunes.search(this.searchTerms)
                this.searchResults = response.data
            } catch (err) {
                console.log(err)
            }
        },
        pop() {
            this.active = true
            return new Promise((resolve, reject) => {
                this.resolve = resolve
                this.reject = reject
            })
        },
        yes() {
            this.resolve(this.selectedResult.collectionId)
            this.active = false
        },
        no() {
            this.resolve(false)
            this.active = false
        },
    },
}
</script>

<style scoped>
.scrollable {
    height: 50vh; /* or any height you want */
    overflow-y: auto;
}
</style>
